import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const AuthorPageStyles = styled.div`
  margin: 20px auto 0 auto;

  .author-info {
    margin: 0 auto;
    max-width: 480px;
    width: 88%;

    .author-image {
      position: relative;
      width: 100%;
    }

    img {
      align-self: center;
      width: 100%;
      height: auto;
    }
    .author-biography {
      margin: 0 auto;
      padding: 20px 0 0 0;
      width: 100%;

      .body-content {
        padding: 0;
      }
      .meet-the-author {
        color: ${Colors.accent.grey1.standard};
        font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
        font-size: 12px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 2.8px;
        line-height: 1.75;
      }
      .biography-text {
        color: ${Colors.accent.grey1.standard};

        .body-content {
          margin: 0;
          padding-top: 10px;
          padding-bottom: 0;

          .body-content-container {
            margin: 0;
          }
        }
      }
    }
  }
  .author-posts {
    .main-heading {
      margin-bottom: 20px;
    }
    .load-more {
      margin-bottom: 90px;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    max-width: 1180px;

    .author-info {
      display: flex;
      justify-content: space-between;
      max-width: none;
      width: 100%;
      margin-bottom: 60px;

      img {
        margin-right: 60px;
        width: auto;
      }

      .author-image {
        margin-right: 60px;
        max-height: 500px;
        max-width: 500px;
      }
    }
  }
`;

export default AuthorPageStyles;
